import * as React from "react";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import OfferPrice from "../offerPrice/offerPrice.js";
import ButtonV2 from "shared/ui/ButtonV2/ButtonV2.js";
import "./styles.css";
export function PriceListInTab(props) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape")
                props.onExit();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [props.onExit]);
    return ReactDOM.createPortal(React.createElement("div", { className: "description-overlay", onClick: props.onExit },
        React.createElement("div", { className: "description-container", onClick: (e) => e.stopPropagation() },
            React.createElement("div", { className: "description-closing-container price-list-closing-container" },
                React.createElement(ButtonV2, { className: "description-closing", onClick: props.onExit, variant: "ghost" }, "\u2716")),
            props.categories.map((category, index) => (React.createElement("div", { key: index },
                React.createElement("h3", null, category.name),
                category.offers.map((offer, index) => (React.createElement(OfferPrice, { offer: offer, key: index })))))))), document.querySelector("#consent-description-container"));
}
